module.exports = __webpack_public_path__ + "static/ritorno-art-deco-75e91f39acc2e01d738b66a7efb6fc65.jpg";